import { render, staticRenderFns } from "./BuyingGroupList.vue?vue&type=template&id=afc142ca&"
import script from "./BuyingGroupList.vue?vue&type=script&lang=js&"
export * from "./BuyingGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports